import { getGuestToken } from '@/api/hypertrackerApi';
import { getOrCreateSearchGuestId } from '@/lib/helpers/guestIdHelpers';

const TOKEN_REFRESH_MARGIN_MS = 30_000;

let cachedGuestToken: string | null = null;
let cachedGuestTokenExpiresAt = 0;

export const getCachedGuestToken = async (forceRefresh = false): Promise<string> => {
    const now = Date.now();
    if (
        !forceRefresh &&
        cachedGuestToken &&
        now < cachedGuestTokenExpiresAt - TOKEN_REFRESH_MARGIN_MS
    ) {
        return cachedGuestToken;
    }

    const guestId = getOrCreateSearchGuestId();
    const { data } = await getGuestToken(guestId);
    cachedGuestToken = data.token;
    cachedGuestTokenExpiresAt = now + data.expiresInSeconds * 1000;
    return cachedGuestToken;
};
